export default "__VITE_ASSET__B8si91vj__"